import { useEffect, useLayoutEffect } from 'react'

/**
 * `useLayoutEffect` runs only in the browser. Using it directly inside a
 * client component that Next.js still renders on the server triggers the
 * "useLayoutEffect does nothing on the server" warning. This hook falls back
 * to `useEffect` on the server and uses `useLayoutEffect` in the browser so we
 * keep the pre-paint behaviour without the warning.
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
